// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__23_UP","unreadBadge":"styles_unreadBadge__18QWd","modalContent":"styles_modalContent__3V0pz","modal":"styles_modal__1SM4P"};